import { PredefinedTableData } from "apis/models/predefinedTable";
import { excludeDefaultTables } from "constants/globals";
import { arrayValidation } from "utils/functions";
import { myTableData } from "apis/models/myTable";

export const getPredefinedTablesByFilters = (predefinedTables: PredefinedTableData[]): PredefinedTableData[] => {
  if (!arrayValidation(predefinedTables)) return predefinedTables;
  return predefinedTables.filter((predefinedTable) =>
    excludeDefaultTables.find((tableName) => tableName === String(predefinedTable.name).toLocaleUpperCase())
      ? false
      : true
  );
};
export const getMyTablesByFilters=(myTables:myTableData[]):myTableData[]=>
{
  if (!arrayValidation(myTables)) return myTables;
  return myTables.filter((myTable) =>
    excludeDefaultTables.find((tableName) => tableName === String(myTable.name).toLocaleUpperCase())
      ? false
      : true
  );
}


